import React from 'react';
import PropTypes from 'prop-types';
import FancyHoverImg from 'core/components/FancyHoverImg';
import {
	Card,
	Title,
	CardDate,
} from 'listing/components/ListicleCards/listicleCardStyles';
import { ResponsiveCheck } from 'core/providers/Responsive';

export const CollectionCard = ({ collectionImages, name, slug, cardType }) => {
	return(
		<ResponsiveCheck>{({ isDesktop }) => (
			<Card href={`/collection/${slug}/`} title={name} collection>
				{collectionImages && (collectionImages[0].thumbnail || collectionImages[0].image)&& (
					<FancyHoverImg
						src={(collectionImages[0].thumbnail || collectionImages[0].image)}
						alt={`Collection image for ${slug}`} title={`Collection image for ${slug}`}
						width={isDesktop ? "400" : "165"}
						height={isDesktop ? "160" : "65"}
					/>
				)}
				<Title>{name}</Title>
				<CardDate>{cardType}</CardDate>
			</Card>
		)}
		</ResponsiveCheck>
	);
};

export const CollectionPropTypes = {
	collectionImages: PropTypes.array,
	name: PropTypes.string,
	slug: PropTypes.string,
	cardType: PropTypes.string,
};

CollectionCard.propTypes = CollectionPropTypes;
CollectionCard.defaultProps = {
	cardType: "Editor's Pick",
};
